import { Component } from "@angular/core";
import { DialogRef, ModalComponent } from "angular2-modal";
import { UserService } from "app/auth/identity/user.service";
import { Message } from "app/server/messages/general";

export interface RemoveUserGroupModalContext {
  objectId: number;
  groupId: number;
}

@Component({
  template: `
    <div class="modal-header">
      <button
        type="button"
        class="close"
        (click)="dialog.dismiss()"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title">Are you sure</h4>
    </div>
    <div class="modal-body">
        <span>This may be the user's only group in Advocus; removing it will effectively deny the user all access to the system.</span>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="dialog.dismiss()">
        Cancel
      </button>
      <button type="button" class="btn btn-danger" (click)="submit()">
        Remove
      </button>
    </div>
  `,
  styles: [
    "/deep/ prettyjson pre {outline: none !important;}",
    "/deep/ #sendButton {position: relative; top: -8px;}",
  ],
})
export class RemoveUserGroupModalComponent
  implements ModalComponent<RemoveUserGroupModalContext>
{
  private objectId: number;
  private groupId: number;

  constructor(
    public dialog: DialogRef<RemoveUserGroupModalContext>,
    public users: UserService
  ) {
    this.objectId = dialog.context.objectId;
    this.groupId = dialog.context.groupId;
  }

  public submit(): void {
    this.users
      .requestRemoveUserGroupsRequest(this.objectId, [this.groupId])
      .subscribe((result: Message) => {
        this.dialog.close((result as any).ok);
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/management/remove-user-group-modal.component.ts